import { cn } from '@/utils/style'
import React from 'react'

const Loading: React.FC<{
  noPadding?: boolean
  className?: string
  count?: number
}> = ({ noPadding, className, count = 4 }) => {
  const padding = noPadding ? '' : 'p-4'

  return (
    <div className={cn(className, padding)}>
      <div className="animate-pulse flex space-x-4">
        <div className="flex-1 space-y-4 py-1">
          <div className="h-4 bg-gray-200 rounded w-3/4" />
          <div className="space-y-4">
            {Array(count)
              .fill(1)
              .map((e, index) => (
                <div key={index} className="h-4 bg-gray-200 rounded" />
              ))}
            <div className="h-4 bg-gray-200 rounded w-5/6" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Loading
